/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react'
import { useTable, ColumnInstance, Row } from 'react-table'
import { useQueryResponseData, useQueryResponseLoading } from '../core/QueryResponseProvider'
import { PortFolios } from '../core/_models'
import { CustomHeaderColumn } from './columns/CustomHeaderColumn'
import { CustomRow } from './columns/CustomRow'
import UsersColumns from './columns/_column'
import { PortFolioPagination } from '../component/pagination/PortFolioPagination'
import { Loader } from '../../../components'

interface DataTableProps {
  selectedColumns?: string[]
  columnOrder?: any[]
  loadingImageIndex?: any
  setLoadingImageIndex?: any
}

const DataTable: React.FC<DataTableProps> = ({ selectedColumns = [], columnOrder = [], loadingImageIndex, setLoadingImageIndex }: any) => {
  const PortFolioData = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const columnsArray = UsersColumns(loadingImageIndex, setLoadingImageIndex);
  const data = useMemo(() => PortFolioData, [PortFolioData])
  
  // Filter and reorder columns based on selectedColumns and columnOrder
  const columns = useMemo(() => {
    if (selectedColumns.length === 0) {
      return columnsArray // Show all columns if none selected
    }
    
    // Always include selection column first
    let filteredColumns = columnsArray.filter(col => {
      const colId = String(col.id || col.accessor || '')
      return colId === 'selection' || selectedColumns.includes(colId)
    })
    
    // Apply column order if provided (but keep selection first)
    if (columnOrder.length > 0) {
      // Create a mapping of column order to indices
      const orderMap = new Map()
      columnOrder.forEach((col, index) => {
        const colId = String(col.id || col.accessor || '')
        orderMap.set(colId, index)
      })
      
      // Sort filtered columns based on the order map (but keep selection first)
      filteredColumns = filteredColumns.sort((a, b) => {
        const aId = String(a.id || a.accessor || '')
        const bId = String(b.id || b.accessor || '')
        
        // Keep selection column always first
        if (aId === 'selection') return -1
        if (bId === 'selection') return 1
        
        const aIndex = orderMap.get(aId) ?? 999
        const bIndex = orderMap.get(bId) ?? 999
        return aIndex - bIndex
      })
    }
    
    return filteredColumns
  }, [selectedColumns, columnOrder, loadingImageIndex])
  
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow}: any = useTable({
    columns,
    data,
  })

  return (
    <>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-table-color fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<PortFolios>) => {
                return <CustomHeaderColumn key={column.id} column={column} />
              })}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<PortFolios>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <>
                <tr>
                  <td colSpan={10}>
                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                      No matching records found
                    </div>
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
      {isLoading && <Loader />}
      {Array.isArray(rows) && rows.length > 0 && <PortFolioPagination />}
    </>
  )
};

export { DataTable }
